import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import * as Yup from "yup";
import { getAccountManagers, getBranchAccountManagerDetail, getBranchAirport, getBranchCity, getBranchCountry, getBranchDetail, getBranchSeaport, getBranchState } from '../../../../../Redux/action/Organisation/Branch/BranchAction';
import { adminMainUrl } from '../../../../../Config';
import axios from 'axios';
import Cookies from "js-cookie";
import { toast } from 'react-toastify';
import Beatloader from '../../../../../Common/Loaders/Beatloader';

const AccountManagers = ({ branch_id, token, user_id, b64id, refresh }) => {
    const dispatch = useDispatch();

    const [showLoader, setShowLoader] = useState(false);
    const [disableSubmit, setDisableSubmit] = useState(false);

    useEffect(() => {
        dispatch(getAccountManagers());
    }, []);


    useEffect(() => {
        if (branch_id && token && user_id && b64id) {
            let customer_id = atob(b64id);
            if (customer_id) {
                dispatch(getBranchAccountManagerDetail(branch_id, token, user_id, customer_id))
            }
        }
    }, [branch_id, token, user_id, b64id]);


    const refreshAccountManagers = () => {
        // console.log("refreshing....");
        // console.log(branch_id, token, user_id, b64id);
        if (branch_id && token && user_id && b64id) {
            let customer_id = atob(b64id);
            if (customer_id) {
                dispatch(getBranchAccountManagerDetail(branch_id, token, user_id, customer_id))
            }
        }
    }


    const {
        loadingBranchAccManagers,
        BranchAccManagersDataError,
        BranchAccManagersData,

        loadingBranchAccManagerDetail,
        BranchAccManagerDetailData,
        BranchAccManagerDetailDataError,
    } = useSelector(state => state?.BranchReducer);


    //populate account managers
    const [managerOptions, setManagerOptions] = useState([]);
    const [loadingManagers, setLoadingManagers] = useState(false);
    useEffect(() => {
        if (loadingBranchAccManagers) {
            setLoadingManagers(true);
        } else {
            setLoadingManagers(false);
        }
        if (BranchAccManagersData) {
            let arr = [];
            BranchAccManagersData.map(val => { arr.push({ value: Number(val.user_id), label: val.name }) });
            setManagerOptions(arr);
        }
    }, [loadingBranchAccManagers, BranchAccManagersDataError, BranchAccManagersData])



    const initialValues = {
        customer_id: "",
        consignee_sea_manager_id: "",
        consignee_land_manager_id: "",
        consignee_air_manager_id: "",
        shipper_air_manager_id: "",
        shipper_sea_manager_id: "",
        shipper_land_manager_id: ""
    }

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: Yup.object({}),
        onSubmit: (values, { resetForm }) => {
            values.customer_id = atob(b64id);

            setDisableSubmit(true);
            try {
                const config = {
                    headers: {
                        'auth-token': Cookies.get('token'),
                        'user_id': Cookies.get('flexichain_user_id')
                    }
                }

                let url = "";

                if (branch_id == 0) {
                    url = ``;
                } else {
                    url = `${adminMainUrl}/api/organization/general/branch/account_manager/add-update`;
                    values.general_branch_id = Number(branch_id);
                }

                if (!values?.consignee_sea_manager_id) { values.consignee_sea_manager_id = null }
                if (!values?.consignee_land_manager_id) { values.consignee_land_manager_id = null }
                if (!values?.consignee_air_manager_id) { values.consignee_air_manager_id = null }
                if (!values?.shipper_air_manager_id) { values.shipper_air_manager_id = null }
                if (!values?.shipper_sea_manager_id) { values.shipper_sea_manager_id = null }
                if (!values?.shipper_land_manager_id) { values.shipper_land_manager_id = null }

                axios.post(url, values, config)
                    .then(response => {
                        if (response.status == 200) {
                            toast.success(response.data.msg);
                            setDisableSubmit(false);
                            refreshAccountManagers();
                            resetForm();
                        } else {
                            toast.error(response.data.msg);
                            setDisableSubmit(false);
                        }
                    }).catch(error => {
                        console.log(error);
                        let msg = "Internal server error."
                        if (error.response) {
                            if (error.response.data) {
                                if (error.response.data.msg) {
                                    msg = error.response.data.msg
                                }
                            }
                        }
                        toast.error(msg);
                        setDisableSubmit(false);
                    });
            } catch (error) {
                console.log(error.message);
                toast.error(error.message);
                setDisableSubmit(false);
            }
        }
    });



    // branch id based selection
    // if 0 -> reset form to add new entries.
    // if !=0 -> use dispatch to set details to edit form

    useEffect(() => {
        if (branch_id == 0) {
            formik.resetForm();
        } else {
            if (branch_id && token && user_id && b64id) {
                let customer_id = atob(b64id);
                if (customer_id) {
                    dispatch(getBranchAccountManagerDetail(branch_id, token, user_id, customer_id))
                }
            }
        }
    }, [branch_id]);


    useEffect(() => {
        if (loadingBranchAccManagers) {
            setShowLoader(true);
        } else {
            setShowLoader(false);
        }

        // console.log("BranchAccManagerDetailData",BranchAccManagerDetailData);

        if (BranchAccManagerDetailData) {
            formik.setFieldValue("consignee_sea_manager_id", BranchAccManagerDetailData?.consignee_sea_manager_id);
            formik.setFieldValue("consignee_land_manager_id", BranchAccManagerDetailData?.consignee_land_manager_id);
            formik.setFieldValue("consignee_air_manager_id", BranchAccManagerDetailData?.consignee_air_manager_id);
            formik.setFieldValue("shipper_air_manager_id", BranchAccManagerDetailData?.shipper_air_manager_id);
            formik.setFieldValue("shipper_sea_manager_id", BranchAccManagerDetailData?.shipper_sea_manager_id);
            formik.setFieldValue("shipper_land_manager_id", BranchAccManagerDetailData?.shipper_land_manager_id);
        }

    }, [loadingBranchAccManagerDetail, BranchAccManagerDetailData, BranchAccManagerDetailDataError,]);

    const customStyles = {
        control: (base) => ({
          ...base,
          height: 29,
          minHeight: 29,
          display: 'flex',
          alignItems: 'center',
        }),
        placeholder: (base) => ({
          ...base,
          display: 'flex',
          alignItems: 'center',
          fontSize: '12px',
          fontWeight: "600",
          color: '#808080',
        }),
        menu: (base) => ({
          ...base,
          fontSize: '12px',
        }),
        option: (base) => ({
          ...base,
          fontSize: '12px',
        }),
        singleValue: (base) => ({
          ...base,
          fontSize: '12px',
          display: 'flex', // Ensure singleValue aligns center vertically
          alignItems: 'center',
        }),
      };


    return (
        <>
            {showLoader ?
                <Beatloader />
                :
                <>
                    <h2 className="accordion-header accordion-custom-button bg-white rounded fw-medium text-dark accordion-header">
                        <button type="button" aria-expanded="true" className="accordion-button">
                            {" "}
                            <span className="avatar avatar-md rounded text-dark border me-2">
                                <i className="ti ti-user-plus fs-20" />
                            </span>
                            Update Account Managers
                        </button>
                    </h2>
                    <form onSubmit={formik.handleSubmit}>
                        <div className="row">
                            <div className="col-6">
                                <div className="mb-3">
                                    <div className=" mb-1 d-flex justify-content-between align-items-center">
                                        <label htmlFor="shipper_air_manager_id" className="form-label mb-0 ">
                                            For Shipper Air
                                        </label>

                                    </div>
                                    <Select
                                        className='custom-selector'
                                        options={managerOptions}
                                        styles={customStyles}
                                        name="shipper_air_manager_id"
                                        value={managerOptions.find(option => option.value === formik.values.shipper_air_manager_id)}
                                        onChange={option => { formik.setFieldValue('shipper_air_manager_id', option.value) }}
                                        onBlur={formik.handleBlur}
                                        isLoading={loadingManagers}
                                    />

                                </div>
                            </div>
                            <div className="col-6">
                                <div className="mb-3">
                                    <div className=" mb-1 d-flex justify-content-between align-items-center">
                                        <label htmlFor="shipper_sea_manager_id" className="form-label mb-0 ">
                                            For Shipper Sea
                                        </label>

                                    </div>
                                    <Select
                                        className='custom-selector'
                                        options={managerOptions}
                                        styles={customStyles}
                                        name="shipper_sea_manager_id"
                                        value={managerOptions.find(option => option.value === formik.values.shipper_sea_manager_id)}
                                        onChange={option => { formik.setFieldValue('shipper_sea_manager_id', option.value) }}
                                        onBlur={formik.handleBlur}
                                        isLoading={loadingManagers}
                                    />

                                </div>
                            </div>
                            <div className="col-6">
                                <div className="mb-3">
                                    <div className=" mb-1 d-flex justify-content-between align-items-center">
                                        <label htmlFor="shipper_land_manager_id" className="form-label mb-0 ">
                                            For Shipper Land
                                        </label>

                                    </div>
                                    <Select
                                        className='custom-selector'
                                        options={managerOptions}
                                        styles={customStyles}
                                        name="shipper_land_manager_id"
                                        value={managerOptions.find(option => option.value === formik.values.shipper_land_manager_id)}
                                        onChange={option => { formik.setFieldValue('shipper_land_manager_id', option.value) }}
                                        onBlur={formik.handleBlur}
                                        isLoading={loadingManagers}
                                    />

                                </div>
                            </div>
                            <div className="col-6">
                                <div className="mb-3">
                                    <div className=" mb-1 d-flex justify-content-between align-items-center">
                                        <label htmlFor="consignee_air_manager_id" className="form-label mb-0 ">
                                            For Consignee Air
                                        </label>
                                    </div>
                                    <Select
                                        className='custom-selector'
                                        options={managerOptions}
                                        styles={customStyles}
                                        name="consignee_air_manager_id"
                                        value={managerOptions.find(option => option.value === formik.values.consignee_air_manager_id)}
                                        onChange={option => { formik.setFieldValue('consignee_air_manager_id', option.value) }}
                                        onBlur={formik.handleBlur}
                                        isLoading={loadingManagers}
                                    />
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="mb-3">
                                    <div className=" mb-1 d-flex justify-content-between align-items-center">
                                        <label htmlFor="consignee_sea_manager_id" className="form-label mb-0 ">
                                            For Consignee Sea
                                        </label>
                                    </div>
                                    <Select
                                        className='custom-selector'
                                        options={managerOptions}
                                        styles={customStyles}
                                        name="consignee_sea_manager_id"
                                        value={managerOptions.find(option => option.value === formik.values.consignee_sea_manager_id)}
                                        onChange={option => { formik.setFieldValue('consignee_sea_manager_id', option.value) }}
                                        onBlur={formik.handleBlur}
                                        isLoading={loadingManagers}
                                    />
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="mb-3">
                                    <div className=" mb-1 d-flex justify-content-between align-items-center">
                                        <label htmlFor="consignee_land_manager_id" className="form-label mb-0 ">
                                            For Consignee Land
                                        </label>
                                    </div>
                                    <Select
                                        className='custom-selector'
                                        options={managerOptions}
                                        styles={customStyles}
                                        name="consignee_land_manager_id"
                                        value={managerOptions.find(option => option.value === formik.values.consignee_land_manager_id)}
                                        onChange={option => { formik.setFieldValue('consignee_land_manager_id', option.value) }}
                                        onBlur={formik.handleBlur}
                                        isLoading={loadingManagers}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="d-flex justify-content-between align-items-center">
                            <div className="d-flex flex-wrap gap-2">
                            </div>
                            <button className="btn btn-sm btn-danger" type='submit' disabled={disableSubmit} >
                                {disableSubmit ? <><i className="fas fa-spinner fa-spin"></i> Saving...</> : `${branch_id ? "Update" : "+ Add"} Managers`}
                            </button>
                        </div>


                    </form>
                </>
            }
        </>

    )
}

export default AccountManagers